import React, { useState } from 'react'
import { Document, Page } from 'react-pdf/dist/esm/entry.webpack'
import './pdf.css'
import { pdfjs } from 'react-pdf'
import ArrowBackIcon from '@material-ui/icons/ArrowBack'
import ArrowForwardIcon from '@material-ui/icons/ArrowForward'
import MarksCoreComponent from './MarksCoreComponent'
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`
import { Button } from 'carbon-components-react'
import { CaretRight, CaretLeft } from '@carbon/icons-react'

function PDFCoreComponent(props) {
  const { pdfData } = props
  const { Width, Height, X, Y, Url, Mark } = pdfData
  const [numPages, setNumPages] = useState(null)
  const [pageNumber, setPageNumber] = useState(1)

  const pdf = {
    Width: Width,
    Height: Height,
    Url: Url,
    X: X,
    Y: Y,
    Mark: Mark
  }

  function onDocumentLoadSuccess({ numPages }) {
    setNumPages(numPages)
  }

  function goToPrevPage() {
    setPageNumber((pageNumber) =>
      pageNumber > 1 ? pageNumber - 1 : pageNumber
    )
  }

  function goToNextPage() {
    setPageNumber((pageNumber) =>
      pageNumber < numPages ? pageNumber + 1 : pageNumber
    )
  }

  return (
    <div
      className='pdf-comp-container'
      style={{
        width: pdf.Width + '%',
        height: pdf.Height + '%',
        left: pdf.X,
        top: pdf.Y
      }}
    >
      <div className='pdf-header-container' style={{ zIndex: 99 }}>
        <Button
          className='replay-rectangle-prop-icons'
          hasIconOnly
          iconDescription='Previous'
          renderIcon={CaretLeft}
          tooltipAlignment='center'
          tooltipPosition='top'
          disabled={pageNumber !== 1 ? false : true}
          onClick={() => {
            goToPrevPage()
          }}
        />
        <span className='pdf-num-pages'>
          {pageNumber} of {numPages} pages
        </span>
        <Button
          className='replay-rectangle-prop-icons'
          hasIconOnly
          iconDescription='Next'
          renderIcon={CaretRight}
          tooltipAlignment='center'
          tooltipPosition='top'
          disabled={pageNumber !== numPages ? false : true}
          onClick={() => {
            goToNextPage()
          }}
        />
      </div>
      <div className='pdf-doc-container'>
        <Document
          className={'react-pdf__Document'}
          style={{ width: '100%', height: '90%' }}
          file={pdf.Url}
          loading={<div>Please wait!</div>}
          onLoadSuccess={onDocumentLoadSuccess}
        >
          <div className='dropableRichZone'>
            <Page className='pdfPage' pageNumber={pageNumber}>
              {pdf.Mark &&
                pdf.Mark.length > 0 &&
                pdf.Mark.map((mark, markIndex) => {
                  if (mark.PageNumber === pageNumber.toString()) {
                    return (
                      <MarksCoreComponent
                        markerData={mark}
                        x={mark.X}
                        y={mark.Y}
                      />
                    )
                  }
                })}
            </Page>
          </div>
        </Document>
      </div>
    </div>
  )
}

export default PDFCoreComponent
